import { Box } from "@mui/material"
import React from "react"
import empty from "src/components/images/empty.png"

import { s } from "../../utilities/common"

export const Footer = ({ top = 116 }: { top?: number }) => {
  return (
    <Box sx={{ position: "relative", height: s("348px"), width: "100%" }}>
      <Box
        component={"img"}
        src={empty}
        sx={{
          position: "absolute",
          top: s(`${top}px`),
          right: s("136px"),
          width: s("240px"),
        }}
      />
    </Box>
  )
}
